class LocalizationDisclosure extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.details?.querySelector('summary');
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onToggle = this.onToggle.bind(this);
  }

  connectedCallback() {
    document.addEventListener('click', this.onDocumentClick);
    this.addEventListener('keyup', this.onKeyUp);
    this.details?.addEventListener('toggle', this.onToggle);
    this.syncExpandedState();
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
    this.removeEventListener('keyup', this.onKeyUp);
    this.details?.removeEventListener('toggle', this.onToggle);
  }

  onDocumentClick(event) {
    if (this.details?.hasAttribute('open') && !this.contains(event.target)) {
      this.close();
    }
  }

  onKeyUp(event) {
    if (event.code === 'Escape' && this.details?.hasAttribute('open')) {
      this.close();
      this.summary?.focus();
    }
  }

  onToggle() {
    if (this.details?.hasAttribute('open')) {
      this.closeSiblingDisclosures();
    }
    this.syncExpandedState();
  }

  close() {
    this.details?.removeAttribute('open');
    this.syncExpandedState();
  }

  closeSiblingDisclosures() {
    const footerGroup = this.closest('.lc-footer__nav, .lc-footer__utility-row');
    if (!footerGroup) return;

    footerGroup.querySelectorAll('.lc-footer__dropdown[open]').forEach((details) => {
      if (details === this.details) return;

      details.removeAttribute('open');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    });
  }

  syncExpandedState() {
    if (!this.summary) return;
    this.summary.setAttribute('aria-expanded', this.details?.hasAttribute('open') ? 'true' : 'false');
  }
}

if (!customElements.get('localization-form')) {
  customElements.define('localization-form', class extends LocalizationDisclosure {});
}

if (!customElements.get('lc-dropdown-disclosure')) {
  customElements.define('lc-dropdown-disclosure', class extends LocalizationDisclosure {});
}
